import { lazy, Suspense, useEffect } from 'react';
import { Loader } from '@mantine/core';
import { BrowserRouter } from 'react-router-dom';

import { getBaseUrl } from '@lib/functions/Navigation';
import { useShallow } from 'zustand/react/shallow';
import { api, queryClient } from '../App';
import { InventoryStatementOutputs } from '../pages/inventory/InventoryStatementOutputs';
import { ProductLabelOutputs } from '../components/buttons/ProductLabelOutputs';
import { ApiProvider } from '../contexts/ApiContext';
import { ThemeContext } from '../contexts/ThemeContext';
import { defaultHostList } from '../defaults/defaultHostList';
import { routes } from '../router';
// Native table modules translate at import time: load only inside the activated locale.
const OfflineCountGate=lazy(()=>import('../offline/OfflineCountGate').then(module=>({default:module.OfflineCountGate})));
import { useLocalState } from '../states/LocalState';

export default function DesktopAppView() {
  const [hostList] = useLocalState(useShallow((state) => [state.hostList]));

  useEffect(() => {
    if (Object.keys(hostList).length === 0) {
      useLocalState.setState({ hostList: defaultHostList });
    }
  }, [hostList]);

  return (
    <ApiProvider client={queryClient} api={api}>
      <ThemeContext>
        <>
          <ProductLabelOutputs />
          <InventoryStatementOutputs />
          <BrowserRouter basename={getBaseUrl()}><Suspense fallback={<Loader/>}><OfflineCountGate>{routes}</OfflineCountGate></Suspense></BrowserRouter>
        </>
      </ThemeContext>
    </ApiProvider>
  );
}
